/** The import's entry points (deliverable 2): the sidebar link and the Settings button. */
import { flagsFromMe } from '@codex/contracts';
import { Button } from '@codex/ui';
import { useLocation } from '@tanstack/react-router';
import { NavLink } from '../shell/nav-link.js';
import { useGoTo } from '../shell/open-doc.js';
import { useShellSession } from '../shell/session.js';
import { importHref } from './href.js';

/** True once the session is known and `flag:import` is on. */
export function useImportEnabled(): boolean {
  const me = useShellSession();
  return me !== null && flagsFromMe(me).import === true;
}

/** The router is read only once the flag is known to be on: with it off nothing is drawn. */
export function SidebarImportEntry() {
  return useImportEnabled() ? <SidebarLink /> : null;
}

function SidebarLink() {
  const pathname = useLocation({ select: (location) => location.pathname });
  return (
    <section className="cx-nav-section" aria-label="Import">
      <ul className="cx-nav-section__list">
        <li className="cx-nav-row-item">
          <NavLink
            href={importHref()}
            icon="upload"
            testId="shell.sidebar.import"
            active={pathname === '/import' || pathname.startsWith('/import/')}
          >
            Import from Notion
          </NavLink>
        </li>
      </ul>
    </section>
  );
}

export function SettingsImportSection() {
  return useImportEnabled() ? <SettingsSection /> : null;
}

function SettingsSection() {
  const goTo = useGoTo();
  return (
    <section aria-labelledby="settings-import" className="cx-settings__import">
      <h2 id="settings-import">Import from Notion</h2>
      <p>Bring a Notion export into the campaign. Nothing is written until you press Import.</p>
      <Button icon="upload" data-testid="settings.import.button" onClick={() => goTo(importHref())}>
        Import from Notion
      </Button>
    </section>
  );
}
